import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/xgh2.jpg';
import _imports_1 from '../../assets/gs.png';
import _imports_2 from '../../assets/xm.png';
import _imports_3 from '../../assets/dh.png';
import _imports_4 from '../../assets/yx.png';
import _imports_5 from '../../assets/zw.png';
import _imports_6 from '../../assets/dfk.png';
import _imports_7 from '../../assets/ewm.png';
import _imports_8 from '../../assets/gzh.jpg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-66de08fc"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "margin": "auto",
    "display": "flex",
    "flex-direction": "row"
  }
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {
      "width": "100%",
      "height": "100%"
    }
  })], -1);
});

var _hoisted_3 = {
  class: "zheng"
};

var _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"one\" style=\"padding:10px;\" data-v-66de08fc><div class=\"one-tu\" data-v-66de08fc><img src=\"" + _imports_1 + "\" data-v-66de08fc></div><div class=\"one-right\" data-v-66de08fc><div style=\"margin:auto;\" data-v-66de08fc>公司名称</div></div></div>", 1);

var _hoisted_5 = {
  class: "bottom"
};
var _hoisted_6 = {
  class: "zheng"
};

var _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"one\" style=\"padding:10px;\" data-v-66de08fc><div class=\"one-tu\" data-v-66de08fc><img src=\"" + _imports_2 + "\" data-v-66de08fc></div><div class=\"one-right\" data-v-66de08fc><div style=\"margin:auto;\" data-v-66de08fc>联系人</div></div></div>", 1);

var _hoisted_8 = {
  class: "bottom"
};
var _hoisted_9 = {
  class: "zheng"
};

var _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"one\" style=\"padding:10px;\" data-v-66de08fc><div class=\"one-tu\" data-v-66de08fc><img src=\"" + _imports_3 + "\" data-v-66de08fc></div><div class=\"one-right\" data-v-66de08fc><div style=\"margin:auto;\" data-v-66de08fc>联系电话</div></div></div>", 1);

var _hoisted_11 = {
  class: "bottom"
};
var _hoisted_12 = {
  class: "zheng"
};

var _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"one\" style=\"padding:10px;\" data-v-66de08fc><div class=\"one-tu\" data-v-66de08fc><img src=\"" + _imports_4 + "\" data-v-66de08fc></div><div class=\"one-right\" data-v-66de08fc><div style=\"margin:auto;\" data-v-66de08fc>邮箱</div></div></div>", 1);

var _hoisted_14 = {
  class: "bottom"
};
var _hoisted_15 = {
  class: "zheng"
};

var _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"one\" style=\"padding:10px;\" data-v-66de08fc><div class=\"one-tu\" data-v-66de08fc><img src=\"" + _imports_5 + "\" data-v-66de08fc></div><div class=\"one-right\" data-v-66de08fc><div style=\"margin:auto;\" data-v-66de08fc>职位</div></div></div>", 1);

var _hoisted_17 = {
  class: "bottom"
};

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_19 = {
  class: "zheng"
};

var _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"one\" style=\"padding:10px;\" data-v-66de08fc><div class=\"one-tu\" data-v-66de08fc><img src=\"" + _imports_6 + "\" data-v-66de08fc></div><div class=\"one-right\" data-v-66de08fc><div style=\"margin:auto;\" data-v-66de08fc>付款截图</div></div></div>", 1);

var _hoisted_21 = {
  class: "bottom"
};
var _hoisted_22 = {
  class: "bottoms"
};
var _hoisted_23 = {
  class: "bottom-btn"
};

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: ""
  })], -1);
});

var _hoisted_25 = [_hoisted_24];
var _hoisted_26 = {
  class: "model"
};

var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "zhe"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "zhe-tu"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: "",
    style: {
      "width": "175px",
      "height": "175px"
    }
  })]), /*#__PURE__*/_createElementVNode("div", {
    class: "zhe-wen"
  }, " 关注公众号，了解更多丰富内容！ ")], -1);
});

var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "dibu"
  }, " Copyright ©2024 东莞市伟凯美智能科技有限公司 ", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_config_provider = _resolveComponent("el-config-provider");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_radio = _resolveComponent("el-radio");

  var _component_el_radio_group = _resolveComponent("el-radio-group");

  var _component_Plus = _resolveComponent("Plus");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_upload = _resolveComponent("el-upload");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_config_provider, {
    locale: $data.locale
  }, null, 8, ["locale"]), _createElementVNode("div", {
    class: "main",
    style: _normalizeStyle('padding-top:' + $data.mainpadding + 'px;')
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["center", {
      'centerShow': $data.bwidth
    }])
  }, [_hoisted_2, _createElementVNode("div", {
    class: "fromstyle",
    style: _normalizeStyle($data.phoneShow ? 'padding: 30px;' : 'padding: 15px;')
  }, [_createElementVNode("h3", {
    style: _normalizeStyle($data.phoneShow ? '' : 'font-size:17px;')
  }, "Vcam热工学沙龙报名表", 4), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
    modelValue: $data.bus.company,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.bus.company = $event;
    }),
    placeholder: "请输入公司名称"
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_input, {
    modelValue: $data.bus.contact,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.bus.contact = $event;
    }),
    placeholder: "请输入联系人"
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_input, {
    modelValue: $data.bus.phone,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.bus.phone = $event;
    }),
    placeholder: "请输入联系电话"
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_input, {
    modelValue: $data.bus.email,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.bus.email = $event;
    }),
    placeholder: "请输入邮箱"
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_radio_group, {
    modelValue: $data.bus.position,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return $data.bus.position = $event;
    }),
    class: "ml-4"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.zwData, function (item, index) {
        return _openBlock(), _createBlock(_component_el_radio, {
          label: item,
          key: index
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(item), 1)];
          }),
          _: 2
        }, 1032, ["label"]);
      }), 128)), _createVNode(_component_el_radio, {
        label: "其它"
      }, {
        default: _withCtx(function () {
          return [_hoisted_18, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return $data.position = $event;
            }),
            maxlength: 10
          }, null, 512), [[_vModelText, $data.position, void 0, {
            trim: true
          }]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_upload, {
    "file-list": $data.urlList,
    "onUpdate:file-list": _cache[6] || (_cache[6] = function ($event) {
      return $data.urlList = $event;
    }),
    action: "http://jhderp.smtjhd.com:6066/ksfbooksignup/upload",
    limit: 1,
    "list-type": "picture-card",
    "on-success": $options.handleAvatarSuccess
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_icon, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_Plus)];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["file-list", "on-success"])])])], 4), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
    class: "bottom-tj",
    onClick: _cache[7] || (_cache[7] = function ($event) {
      return $options.busAdd(_ctx.ruleFormRef);
    })
  }, " 提交 ")])])], 2), $data.phoneShow ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "tu",
    onClick: _cache[8] || (_cache[8] = function () {
      return $options.tuShow && $options.tuShow.apply($options, arguments);
    })
  }, _hoisted_25)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_dialog, {
    modelValue: $data.imgStatus,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
      return $data.imgStatus = $event;
    }),
    width: "240px",
    draggable: true,
    "close-on-click-modal": false
  }, {
    default: _withCtx(function () {
      return [_hoisted_27];
    }),
    _: 1
  }, 8, ["modelValue"])])], 4), _hoisted_28]);
}